var map = {
	"./af.json": "8334",
	"./am.json": "3dc4",
	"./ar.json": "3396",
	"./az.json": "abb7",
	"./be.json": "40cd",
	"./bg.json": "b5aa",
	"./bn.json": "70cb",
	"./bs.json": "f9f7",
	"./ca.json": "5bc9",
	"./cs.json": "fe60",
	"./cy.json": "3933",
	"./da.json": "68cd",
	"./de.json": "4230",
	"./dv.json": "22fc5",
	"./el.json": "b400",
	"./en.json": "27a6",
	"./es.json": "00ae",
	"./et.json": "61b2",
	"./eu.json": "c52a",
	"./fa.json": "be7e",
	"./fi.json": "19c2",
	"./fr.json": "a611",
	"./gl.json": "12ba",
	"./ha.json": "4a69",
	"./he.json": "4024",
	"./hi.json": "481e",
	"./hr.json": "0e1f",
	"./hu.json": "2bd2",
	"./hy.json": "be6d",
	"./id.json": "dbbf",
	"./is.json": "af3f",
	"./it.json": "cd3d",
	"./ja.json": "7fdd",
	"./ka.json": "0d4d",
	"./kk.json": "2456",
	"./km.json": "1e7f",
	"./ko.json": "e615",
	"./ku.json": "4f8e",
	"./ky.json": "a62a",
	"./lt.json": "32b4",
	"./lv.json": "efa4",
	"./mk.json": "22d2",
	"./ml.json": "fac9",
	"./mn.json": "2c5d0",
	"./mr.json": "5b4e",
	"./ms.json": "4538",
	"./nb.json": "3b79",
	"./nl.json": "4c63",
	"./nn.json": "c386",
	"./no.json": "6a93",
	"./pl.json": "dacb",
	"./ps.json": "6e1d",
	"./pt.json": "7443",
	"./ro.json": "ae02",
	"./ru.json": "e84b",
	"./sd.json": "cd01",
	"./sk.json": "1842",
	"./sl.json": "808d",
	"./so.json": "109c",
	"./sq.json": "8f12",
	"./sr.json": "c758",
	"./sv.json": "91c7",
	"./sw.json": "aabd",
	"./ta.json": "f011",
	"./tg.json": "63c7",
	"./th.json": "c62f",
	"./tr.json": "8f2e",
	"./tt.json": "e91d",
	"./ug.json": "b353",
	"./uk.json": "a06e",
	"./ur.json": "7634",
	"./uz.json": "0a7a",
	"./vi.json": "d02f",
	"./zh.json": "875f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b99d";